"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.bindProviderToContainer = void 0;
const isNewable_1 = __importDefault(require("../validation/isNewable"));
const setScope_1 = __importDefault(require("./setScope"));
const isClassProvider_1 = __importDefault(require("../validation/isClassProvider"));
const isAsyncFactoryProvider_1 = __importDefault(require("../validation/isAsyncFactoryProvider"));
const isFactoryProvider_1 = __importDefault(require("../validation/isFactoryProvider"));
const isValueProvider_1 = __importDefault(require("../validation/isValueProvider"));
const constants_1 = require("../constants");
const inversifySugarOptions_1 = __importDefault(require("../inversifySugarOptions"));
const bindProviderToContainer = (provider, container) => {
    if ((0, isNewable_1.default)(provider)) {
        const newableProvider = provider;
        const scope = inversifySugarOptions_1.default.defaultScope;
        (0, setScope_1.default)(container.bind(newableProvider).toSelf(), scope).whenTargetTagged(constants_1.PROVIDED_TAG, true);
    }
    else if ((0, isClassProvider_1.default)(provider)) {
        const classProvider = provider;
        const scope = classProvider.scope || inversifySugarOptions_1.default.defaultScope;
        const bindingOnSyntax = (0, setScope_1.default)(classProvider.provide
            ? container.bind(classProvider.provide).to(classProvider.useClass)
            : container.bind(classProvider.useClass).toSelf(), scope).whenTargetTagged(constants_1.PROVIDED_TAG, true);
        classProvider.onActivation &&
            bindingOnSyntax.onActivation(classProvider.onActivation);
        scope === "Singleton" &&
            classProvider.onDeactivation &&
            bindingOnSyntax.onDeactivation(classProvider.onDeactivation);
    }
    else if ((0, isValueProvider_1.default)(provider)) {
        const valueProvider = provider;
        const bindingOnSyntax = container
            .bind(valueProvider.provide)
            .toConstantValue(valueProvider.useValue)
            .whenTargetTagged(constants_1.PROVIDED_TAG, true);
        valueProvider.onActivation &&
            bindingOnSyntax.onActivation(valueProvider.onActivation);
        valueProvider.onDeactivation &&
            bindingOnSyntax.onDeactivation(valueProvider.onDeactivation);
    }
    else if ((0, isFactoryProvider_1.default)(provider)) {
        const factoryProvider = provider;
        const bindingOnSyntax = container
            .bind(factoryProvider.provide)
            .toFactory(factoryProvider.useFactory)
            .whenTargetTagged(constants_1.PROVIDED_TAG, true);
        factoryProvider.onActivation &&
            bindingOnSyntax.onActivation(factoryProvider.onActivation);
        factoryProvider.onDeactivation &&
            bindingOnSyntax.onDeactivation(factoryProvider.onDeactivation);
    }
    else if ((0, isAsyncFactoryProvider_1.default)(provider)) {
        const asyncFactoryProvider = provider;
        const bindingOnSyntax = container
            .bind(asyncFactoryProvider.provide)
            .toProvider(asyncFactoryProvider.useAsyncFactory)
            .whenTargetTagged(constants_1.PROVIDED_TAG, true);
        asyncFactoryProvider.onActivation &&
            bindingOnSyntax.onActivation(asyncFactoryProvider.onActivation);
        asyncFactoryProvider.onDeactivation &&
            bindingOnSyntax.onDeactivation(asyncFactoryProvider.onDeactivation);
    }
};
exports.bindProviderToContainer = bindProviderToContainer;
